<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>
    <md-card>
      <md-card-content>
        <div class="box">
          <div class="box-header">
            <h3 class="box-title">Air Import Details</h3>
          </div>
          <hr class="hr-s" />
          <!-- /.box-header -->
          <div class="box-body">
            <table id="conBooking" class="table table-bordered table-striped">
              <thead>
                <tr>
                  <!-- <th>Sr no</th> -->
                  <th>Assignment</th>

                  <th>More Details</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item1, index) in AirImportData" :key="index">
                  <!-- <td>{{index+1}}</td> -->

                  <td
                    @click="
                      viewExportAirPage(item1.ffairImportId, item1.statusFinal)
                    "
                    class="showMoreData"
                  >
                    <b>Assignment No. :</b>
                    {{ item1.airImportSeries }}
                    <br />
                    <b>Importer Client :</b>
                    {{ item1.importerClient }}
                    <br />
                    <b>Exporter Client :</b>
                    {{ item1.exporterClient }}
                    <br />

                    <b>AirType :</b>
                    {{ item1.containerInfo }}
                  </td>
                  <td>
                    <b>Place of Receipt :</b>
                    {{ item1.placeRecp }}
                    <br />
                    <b>Airport of Departure :</b>
                    {{ item1.placeDis }}
                    <br />
                    <b>Airport of Arrival:</b>
                    {{ item1.LoadPort }}
                    <br />
                    <b>FPOD :</b>
                    {{ item1.finalPlace }}
                    <br />
                  </td>
                  <!-- <td>{{index+1}}</td>
                  <td>{{item1.airImportSeries}}</td>
                  <td>{{item1.containerInfo}}</td>-->
                </tr>
              </tbody>
            </table>
          </div>
          <!-- /.box-body -->
        </div>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";

import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";

export default {
  beforeMount() {
    if (globalPermissionStatus("Client")) {
      this.$store.dispatch(
        "setCurrentRoute",
        "/airImport/viewAirImportDetails"
      );
      this.viewFFExportFCL();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },

  data() {
    return {
      isLoading: false,
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },

      AirImportData: [],
    };
  },

  mounted() {
    // this.JqueryFun()
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    // Loading
    CustomLoader,
  },

  computed: {},

  methods: {
    goToMain() {
      this.$sessionsStorage.set("editffAirImportId", "");
      this.$router.push({
        path: "/airImport/ffairImportFcl",
      });
    },
    JqueryFun() {
      return $(function () {
        return $("#conBooking").DataTable();
      });
    },

    viewExportAirPage(AIR, status) {
      this.$sessionsStorage.set("editffAirImportId", AIR);
      let data = {
        jobType: "1",
        typeOf: "3",
        status: "",
        msgType: "1",
        allMessageId: AIR,
        statusMain: status,
      };

      this.$sessionsStorage.set("MessageStatus", JSON.stringify(data));

      this.$router.push({
        path: "/UpdateStatus/clientChatScreen",
      });
    },
    viewFFExportFCL() {
      this.isLoading = true;
      let payload = {
        view: "view",
      };
      // console.log("sasas",payload)
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_ClientDashboard/viewAirImportList.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            //console.log("avccc", data);
            if (data.AirImportDetails.length > 0) {
              this.AirImportData = data.AirImportDetails;
            }
            this.isLoading = false;

            this.JqueryFun();
          }
        })
        .catch((error) => {});
    },
  },
};
</script>
<style></style>



// WEBPACK FOOTER //
// clientAirImportDetails.vue?43378a3c